<template>
  <a-card :bordered="false">
    <!-- 表格筛选 start -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @submit="handleSubmit">
        <a-row :gutter="48">
          <!-- 输入关键词查找 -->
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="旺旺名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请输入旺旺名查询" v-model="queryParam.uaccount" @change="handleSubmit"></a-input>
            </a-form-item>
          </a-col> -->
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-range-picker @change="onDateChange" />
            </a-form-item>
          </a-col> -->
          <template v-if="advanced">
          </template>
          <!-- 展开或者收起筛选项 start -->
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="{ float: !advanced && 'left' || 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" htmlType="submit">刷新</a-button>
              <!-- <a-button style="margin-left: 8px" @click="reset">重置</a-button> -->
              <!-- <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a> -->
            </span>
          </a-col>
          <!-- 展开或者收起筛选项 end -->
        </a-row>
      </a-form>
    </div>
    <!-- 表格筛选 end -->
    <!-- 表格内容操作 start -->
    <div class="table-operator">
      <!-- <a-button type="primary" @click="openAddDrawer" style="margin-right:15px;">添加订单</a-button> -->
      <!-- <a-button v-if="hasPerm('exportOrder')" type="primary" style="margin-right:15px;">全部导出</a-button> -->
      <!-- <a-button type="dashed" @click="toggleTableAlert()">{{ optionAlertShow && '关闭' || '开启' }}多选</a-button>
      <a-dropdown v-if="optionAlertShow && selectedRowKeys.length > 0">
        <a-menu slot="overlay" @click="handleMenuClick">
          <a-menu-item key="1"><a-icon type="file-zip" />删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down" />
        </a-button>
      </a-dropdown> -->
      <!-- <a-radio-group style="float:right" v-model="queryParam.status" @change="handleSubmit">
        <a-radio-button v-for="status in dict.statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
      </a-radio-group> -->
    </div>
    <!-- 表格内容操作 end -->
    <!-- 表格 start -->
    <tcg-table
      ref="table"
      size="default"
      rowKey="order_id"
      :columns="columns"
      :data="loadData"
      :alert="options.alert"
      :pageSize="10"
      :rowSelection="options.rowSelection"
      bordered
    >
    </tcg-table>
    <!-- 表格 end -->
  </a-card>
</template>
<script>
import { getPre, getList } from '@/api/orders'
import { TcgTable } from '@/components'
import _ from 'lodash'

export default {
  components: {
    TcgTable
  },
  data () {
    return {
      labelCol: {
        span: 5
      },
      wrapperCol: {
        span: 18,
        offset: 1
      },
      // 时间
      time: [],
      // 查看抽屉状态开关
      viewVisible: false,
      // 添加抽屉
      addDrawerVisible: false,
      // id
      id: '',
      // 字典
      dict: {
        cnameDict: [],
        statusDict: []
      },
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        status: ''
      },
      // 表头
      columns: [
        // {
        //   title: 'ID',
        //   dataIndex: 'order_id',
        //   fixed: 'left',
        //   width: '100px'
        // },
        // {
        //   title: '淘宝订单号',
        //   dataIndex: 'orderId',
        //   fixed: 'left',
        //   width: '200px'
        // },
        // {
        //   title: '旺旺名',
        //   dataIndex: 'uaccount',
        //   width: '200px'
        // },
        {
          title: '课程名称',
          dataIndex: 'cname'
        },
        // {
        //   title: '指定教材',
        //   dataIndex: 'material',
        //   width: '280px'
        // },
        {
          title: '开始日期',
          dataIndex: 'stime'
        },
        {
          title: '截止日期',
          dataIndex: 'etime'
        },
        {
          title: '购买数量',
          dataIndex: 'paynum'
        },
        {
          title: '赠送数量',
          dataIndex: 'givenum'
        },
        // {
        //   title: '体验课老师',
        //   dataIndex: 'tname',
        //   width: '100px'
        // },
        {
          title: '已完成',
          dataIndex: 'done_num'
        },
        {
          title: '待上课',
          dataIndex: 'wait_num'
        },
        {
          title: '扣学时',
          dataIndex: 'deduct'
        },
        {
          title: '可预约',
          dataIndex: 'surplus_num'
        },
        // {
        //   title: '续课记录',
        //   dataIndex: 'continuationlog',
        //   width: '180px'
        // },
        // {
        //   title: '订单奖金',
        //   dataIndex: 'award_money',
        //   width: '180px'
        // },
        // {
        //   title: '订单时间',
        //   dataIndex: 'create_time',
        //   width: '180px'
        // },
        // {
        //   title: '备注',
        //   dataIndex: 'remark',
        //   width: '300px'
        // },
        // {
        //   title: '状态',
        //   dataIndex: 'status',
        //   width: '150px'
        // },
        // {
        //   title: '操作',
        //   dataIndex: 'order_id',
        //   key: 'action',
        //   width: '150px',
        //   scopedSlots: { customRender: 'action' }
        // }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      // custom table alert & rowSelection
      options: {
        alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          Time: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created () {
    this.toggleTableAlert()
    this.handelPre()
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 重置按钮
    reset () {
      this.queryParam = {}
    },
    // 提交筛选
    handleSubmit (e) {
      e.preventDefault()
      this.$refs.table.refresh(true)
    },
    // 切换提示
    toggleTableAlert () {
      if (!this.optionAlertShow) {
        this.options = {
          alert: { show: true, clear: () => { this.selectedRowKeys = [] } },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
</style>
